import forOwn from "lodash/forOwn";
import { PatientEstimateBase } from "../../../../../backend/src/graph/patient_estimates/patient-estimate-base";

export class PatientEstimateEntry extends PatientEstimateBase {
  constructor(baseItem?: PatientEstimateBase) {
    super();
    if (!baseItem) return;
    forOwn(baseItem, (value, key) => {
      this[key] = value;
    });
  }
}

export class TreatmentPlanEntry {
  public treatment_plan_id: number;
  public estimates: Array<PatientEstimateEntry>;
  public private_treatment_value: string;

  public get treatment_plan_completed(): boolean {
    return this.estimates.every((e) => e.treatment_plan_completed);
  }
}
